

export default [{
  path: '/bigMap',
  name: 'bigMap',
  component: () => import('@/views/home/big-map/index'),
}]
